import React from 'react';
import { mockCase, mockDiscoverySets } from '../data/mockData';
export function CaseHeader() {
  const totalQuestions = mockDiscoverySets.reduce((acc, set) => acc + set.questionCount, 0);
  const totalResponses = mockDiscoverySets.reduce((acc, set) => acc + (set.questions?.length || 0), 0);
  const pendingSets = mockDiscoverySets.filter(set => set.status === 'Pending' || set.status === 'Overdue' || set.status === 'Partial').length;
  return <div className="bg-navy-surface border-b border-navy-border sticky top-0 z-10" data-id="element-7">
      <div className="px-6 py-4" data-id="element-8">
        <div className="flex justify-between items-start mb-3" data-id="element-9">
          <div data-id="element-10">
            <h1 className="text-lg font-semibold text-white tracking-tight mb-1" data-id="element-11">
              {mockCase.name}
            </h1>
            <div className="flex items-center gap-4 text-xs text-text-secondary" data-id="element-12">
              <span className="flex items-center gap-1" data-id="element-13">
                <span className="text-text-muted" data-id="element-14">Case No:</span>{' '}
                {mockCase.number}
              </span>
              <span className="text-navy-border" data-id="element-15">|</span>
              <span className="flex items-center gap-1" data-id="element-16">
                <span className="text-text-muted" data-id="element-17">Court:</span> {mockCase.court}
              </span>
              <span className="text-navy-border" data-id="element-18">|</span>
              <span className="flex items-center gap-1" data-id="element-19">
                <span className="text-text-muted" data-id="element-20">Judge:</span> {mockCase.judge}
              </span>
            </div>
          </div>
          <div className="bg-navy-elevated border border-navy-border rounded-sm px-3 py-1.5 text-xs text-text-secondary flex gap-4" data-id="element-21">
            <div className="flex flex-col items-center" data-id="element-22">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-23">
                Parties
              </span>
              <span className="font-semibold text-white" data-id="element-24">
                {mockCase.parties.length}
              </span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-25"></div>
            <div className="flex flex-col items-center" data-id="element-26">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-27">
                Sets
              </span>
              <span className="font-semibold text-white" data-id="element-28">
                {mockDiscoverySets.length}
              </span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-29"></div>
            <div className="flex flex-col items-center" data-id="element-30">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-31">
                Q's
              </span>
              <span className="font-semibold text-white" data-id="element-32">{totalQuestions}</span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-33"></div>
            <div className="flex flex-col items-center" data-id="element-34">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-35">
                Resp
              </span>
              <span className="font-semibold text-white" data-id="element-36">{totalResponses}</span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-37"></div>
            <div className="flex flex-col items-center" data-id="element-38">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-39">
                Pending
              </span>
              <span className="font-semibold text-accent-amber" data-id="element-40">
                {pendingSets}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}